import { render } from "./CortonaINS.vue?vue&type=template&id=3ed4e742&scoped=true"
import script from "./CortonaINS.vue?vue&type=script&lang=js"
export * from "./CortonaINS.vue?vue&type=script&lang=js"

import "./CortonaINS.vue?vue&type=style&index=0&id=3ed4e742&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.32_vue@3.5.32_typescript@5.9.3__webpack@5.105.4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ed4e742"]])

export default __exports__